/**
 * <FreeDrawButton>: starts a solo/shared Free Draw session.
 *
 * Item 1 moved Free Draw off the landing and onto the "What is this?" (/about)
 * page. This component owns the CTA: it POSTs /api/free-draw via the shared
 * useRoomCreator hook (the same create+navigate path the landing's "Create a
 * game" uses) and is gated on the WS session, so it stays disabled until the
 * connection is live.
 */

import type { ConnState } from "../ws.js";
import { ScribbleButton } from "./ScribbleButton.js";
import { useRoomCreator } from "../hooks/useRoomCreator.js";

type FreeDrawButtonProps = {
  connState: ConnState;
};

export function FreeDrawButton({ connState }: FreeDrawButtonProps) {
  const { create, creating, error, ready } = useRoomCreator(connState);
  return (
    <>
      <ScribbleButton
        variant="secondary"
        onClick={() => create("/api/free-draw")}
        disabled={!ready || creating}
        aria-label="Start a Free Draw session"
      >
        {creating ? "Creating…" : "Free Draw"}
      </ScribbleButton>
      {error && (
        <p class="status" data-state="error" role="alert">
          {error}
        </p>
      )}
    </>
  );
}
